export default __webpack_public_path__ + "static/media/outlay.d11470c7.jpeg";